import { Controller } from "@hotwired/stimulus"

// Infinite scroll for the Recently Submitted feed. Watches the sentinel at the
// bottom of the list; when it nears the viewport, fetches the next page
// fragment (rows plus a fresh sentinel, or none when exhausted) and swaps it
// in for the old sentinel. Target connected/disconnected callbacks re-arm the
// observer across swaps.
export default class extends Controller {
  static targets = ["sentinel"]

  initialize() {
    // Created here, not connect(): sentinelTargetConnected fires before connect.
    this.observer = new IntersectionObserver(
      (entries) => { if (entries.some((entry) => entry.isIntersecting)) this.#loadNext() },
      { rootMargin: "200px" }
    )
  }

  sentinelTargetConnected(element) {
    this.observer.observe(element)
  }

  sentinelTargetDisconnected(element) {
    this.observer.unobserve(element)
  }

  disconnect() {
    this.observer.disconnect()
  }

  async #loadNext() {
    if (this.loading || !this.hasSentinelTarget) return
    this.loading = true
    try {
      const response = await fetch(this.sentinelTarget.dataset.url, { headers: { Accept: "text/html" } })
      if (response.ok) this.sentinelTarget.outerHTML = await response.text()
    } finally {
      this.loading = false
    }
  }
}
